// FILTERS STORE

// CONFIGURATION STATE
const state = {
  globalFilter: [],
  isGlobalFilterLoaded: false,
  filterList: [],
  initialDataLink: {},
  role: ''
}

// GETTERS
const getters = {
  getGlobalFilters (state) {
    return state.globalFilter
  },
  getGlobalIsLoaded (state) {
    return state.isGlobalFilterLoaded
  },
  getFilterList (state) {
    return state.filterList
  },
  getInitialDataLink (state) {
    return state.initialDataLink
  },
  getRole (state) {
    return state.role
  }
}
// ACTIONS
const actions = {
  // RESET GLOBAL FILTERS
  resetGlobalFilters ({ commit, state }) {
    commit('RESET_LOADERS')
    commit('RESET_GLOBAL_FILTERS')
  },

  // SET GLOBAL FILTER FROM CONF. AND SET IN FILTERS
  initGlobalFilters ({ commit, rootGetters }) {
    var currentGlobalFilter = rootGetters.getCurrentFilters
    commit('SET_GLOBAL_FILTER', currentGlobalFilter)

    // SET FILTER LIST
    var filters = currentGlobalFilter.length > 0 ? currentGlobalFilter.map(x => x.id).sort((a, b) => a.filterOrder - b.filterOrder) : []
    commit('SET_FILTER_LIST', filters)

    // SET LOADED (to avoid load again)
    commit('SET_GLOBAL_LOADED', true)
  },

  // SET DATA ROLE (some filters need to filter by role)
  async initDataRole ({ commit }, action) {
    try {
      var user = "'" + action.user + "'"
      const role = await window.DSApi.inst1.api.ds.from('mdp_role_view').filter('user_entity.user', user).exec()
      var currentRole = role[0].user_entity.org_niv1
      commit('SET_ROLE_FILTER', currentRole)
      return currentRole
    } catch (error) {
      console.log(error)
      return error
    }
  },

  // SET DATA TO FILTER ITEM
  async initDataFilter ({ commit, getters }, filterId) {
    try {
      var filterConfiguration = (getters.getGlobalFilters).filter(x => x.id === filterId).map(y => y.filter)[0]
      var filterData = []
      if (filterConfiguration.source !== '' && filterConfiguration.dataSource.length === 0) {
        // check: need filter?
        if (filterConfiguration && filterConfiguration.isFilterable === true) {
          var type = filterConfiguration.isFilterable ? filterConfiguration.filterBy : ''
          if (type === 'role') {
            // filter by role
            var role = getters.getRole
            var roleFilter = role === '#admin' ? [] : [{ field: filterConfiguration.field, exp: "'" + role + "'" }] // special value #admin detection
            filterData = await window.DSApi.inst1.api.ds.from(filterConfiguration.source).filter(roleFilter).exec()
            filterData = filterData.length > 0 ? filterData.map(x => ({ ...x, id: Math.random() })) : filterData // set uniqueID
            commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: 'filter', elem: 'dataSource', data: filterData }) // original data
            commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: '', elem: 'data', data: filterData }) // real data (can be filtered)
            // if role <> #admin load activeFilter one value
            if (role !== '#admin') {
              commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: 'filter', elem: 'activeFilter', data: filterData[0][filterConfiguration.field] })
              commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: 'schema', elem: 'isVisible', data: false })
            }
          } else if (type === 'user') {
            // filter by user
          }
        } else {
          // no-filter
          filterData = await window.DSApi.inst1.api.ds.from(filterConfiguration.source).exec()
          filterData = filterData.length > 0 ? filterData.map(x => ({ ...x, id: Math.random() })) : filterData
          commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: 'filter', elem: 'dataSource', data: filterData }) // no-fiter  original data
          commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: '', elem: 'data', data: filterData }) // no-filter real data (can be filtered)
        }
      } else {
        var msg = filterConfiguration.source === '' ? ' Filter with no datasource needed.' : ' Filter Already Loaded.'
        console.log(filterConfiguration.id, msg)
      }
      // return data
      return filterData
    } catch (error) {
      console.log(error)
      return error
    }
  },

  // FILTER DATA IN FILTER ITEM BY OTHER FILTER
  async filterDataFilter ({ commit, getters }, action) {
    try {
      var filterId = action.id
      var filterValue = action.value
      var filterField = action.field
      var filterData = (getters.getGlobalFilters).filter(x => x.id === filterId).map(y => y.filter.dataSource)[0]
      var newDataFiltered = filterData.filter(x => x[filterField] === filterValue) || filterData
      commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: '', elem: 'data', data: newDataFiltered })
      return newDataFiltered
    } catch (error) {
      console.log(error)
    }
  },

  // SEND FILTER TO DASHBOARD
  sendFilter ({ commit, getters }, filter) {
    var filterId = filter.filterId
    var filterValue = filter.value
    var filterOp = filter.op || ''
    var filterConfiguration = (getters.getGlobalFilters).filter(x => x.id === filterId)[0]
    var externalFilterId = filterConfiguration.filter.id

    // AUX: for fields that use key (when field not have uniqueId key generates one´s with format: {parent-value} always the 2nd value is the filter value. )
    var keyParser = (data) => {
      if ((typeof data === 'string' && data === '') || (typeof data === 'object' && data.length === 0)) {
        return data
      } else {
        if (typeof data === 'string') { return data.split('-')[1] } else { return data.map(x => x.split('-')[1]) }
      }
    }

    // field types
    if (filterConfiguration.schema.fieldType === 'datePicker') {
      if (filterValue === '') { filterValue = null }
      window.DSApi.inst1.api.sendFilter(externalFilterId, filterConfiguration.filter.field, filterValue, filterOp)
    } else if (filterConfiguration.schema.fieldType === 'SelectList') {
      // SelectList
      if (filterConfiguration.schema.multi) {
        var activeValue = ''
        // multiple-value filter
        if (filterValue.length === 0) {
          // special filter null
          window.DSApi.inst1.api.sendFilter(externalFilterId, filterConfiguration.filter.field, null, 'IN')
          commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: 'filter', elem: 'activeFilter', data: [] })
        } else {
          // normal multi-value to SQL(IN) sentence
          if (filterConfiguration.schema.key !== '') { activeValue = keyParser(filterConfiguration.filter.activeFilter) } else { activeValue = filterConfiguration.filter.activeFilter } // if key for UniqueID
          var multiValue = filterConfiguration.schema.type === 'string' ? '(' + activeValue.map(x => "'" + x + "'").join(',') + ')' : '(' + activeValue.join(',') + ')'
          window.DSApi.inst1.api.sendFilter(externalFilterId, filterConfiguration.filter.field, multiValue, 'IN')
          commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: 'filter', elem: 'activeFilter', data: filterValue })
        }
      } else {
        // single-value filter
        if (filterConfiguration.schema.key !== '') { activeValue = keyParser(filterConfiguration.filter.activeFilter) } else { activeValue = filterConfiguration.filter.activeFilter } // if key for UniqueID
        if (filterValue === '') { activeValue = null }
        window.DSApi.inst1.api.sendFilter(externalFilterId, filterConfiguration.filter.field, activeValue)
        commit('UPDATE_GLOBAL_FILTER', { id: filterId, key: 'filter', elem: 'activeFilter', data: filterValue === null ? '' : filterValue })
      }
    }
  },

  // UPDATE GLOBAL FILTER PROPERTIES
  updateGlobalFilters ({ commit, state }, payload) {
    commit('UPDATE_GLOBAL_FILTER', payload)
  },

  // CHECK FILTERS (INITIAL DATALINK)
  checkInitialFilters ({ commit, getters, state }) {
    var currentGlobalFilter = getters.getGlobalFilters
    var filters = getters.getFilterList
    var field = {}
    var initial = []
    var initialDataLink = {}

    // AUX: for datePicker fields
    var dateParser = (value) => {
      const date = new Date(value)
      let month = (date.getMonth() + 1).toString()
      const year = date.getFullYear().toString()
      month = month.length === 1 ? `0${month}` : month
      return parseInt(year + month)
    }

    // AUX: for fields that use key (when field not have uniqueId key generates one´s with format: {parent-value} always the 2nd value is the filter value. )
    var keyParser = (data) => {
      if ((typeof data === 'string' && data === '') || (typeof data === 'object' && data.length === 0)) {
        return data
      } else {
        if (typeof data === 'string') {
          return data.split('-')[1]
        } else {
          return data.map(x => x.split('-')[1])
        }
      }
    }

    // Iterate all fields , if any has activeFilter Value setted, then add it to the initialDataLink
    for (let i = 0; i < filters.length; i++) {
      field = currentGlobalFilter.filter(x => x.id === filters[i])[0]
      if (field.schema.fieldType === 'datePicker') {
        // Daterangepicker filter
        var dateValue = field.filter.activeFilter === null ? '' : field.filter.activeFilter
        if (dateValue !== '') {
          if (field.schema.dateManager === 'custom') {
            dateValue = dateValue + ' and ' + dateValue
          } else {
            const now = new Date()
            var dateNowParsed = dateParser(now)
            dateValue = dateValue + ' and ' + dateNowParsed
          }
          const dateOp = 'between'
          initial = [{ field: field.filter.field, value: dateValue, op: dateOp }]
          initialDataLink[field.filter.id] = initial
        }
      } else if (field.schema.fieldType === 'SelectList') {
        // selectField filter
        var activeValue = ''
        if (field.schema.multi) {
          if (field.filter.activeFilter.length > 0) {
            if (field.schema.key !== '') { activeValue = keyParser(field.filter.activeFilter) } else { activeValue = field.filter.activeFilter }
            var multiValue = field.schema.type === 'string' ? '(' + activeValue.map(x => "'" + x + "'").join(',') + ')' : '(' + activeValue.join(',') + ')'
            initial = [{ field: field.filter.field, value: multiValue, op: 'IN' }]
            initialDataLink[field.filter.id] = initial
          }
        } else {
          if (field.filter.activeFilter !== '') {
            if (field.schema.key !== '') { activeValue = keyParser(field.filter.activeFilter) } else { activeValue = field.filter.activeFilter }
            var singleValue = field.filter.activeFilter
            initial = [{ field: field.filter.field, value: singleValue, op: '=' }]
            initialDataLink[field.filter.id] = initial
          }
        }
      }
    }
    // Set initialDataLink even if is void (setup)
    commit('SET_INITIAL_DATALINK', initialDataLink)
  }
}

// MUTATIONS
const mutations = {
  'RESET_LOADERS' (state) {
    state.isGlobalFilterLoaded = false
  },
  'RESET_GLOBAL_FILTERS' (state) {
    Object.assign(state.globalFilter, [])
  },
  'SET_GLOBAL_FILTER' (state, payload) {
    state.globalFilter = payload
  },
  'SET_GLOBAL_LOADED' (state, payload) {
    state.isGlobalFilterLoaded = payload
  },
  'SET_FILTER_LIST' (state, payload) {
    state.filterList = payload
  },
  'SET_ROLE_FILTER' (state, payload) {
    state.role = payload
  },
  'SET_INITIAL_DATALINK' (state, payload) {
    state.initialDataLink = payload
  },
  'UPDATE_GLOBAL_FILTER' (state, payload) {
    var data = {}
    data[payload.elem] = payload.data
    if (payload.key !== '') {
      Object.assign(state.globalFilter.filter(x => x.id === payload.id)[0][payload.key], data)
    } else {
      Object.assign(state.globalFilter.filter(x => x.id === payload.id)[0], data)
    }
  }
}
// EXPORT SECTION
export default {
  state,
  getters,
  actions,
  mutations
}
